import SidebarInvestigationDetails from "security-app/components/Investigations/Details/SidebarInvestigationDetails";
const HEX_OBJECT_ID = /^[0-9a-fA-F]{24}$/;
const ULID = /^[0-9A-HJKMNP-TV-Z]{26}$/;
const isObjectId = (value) => !!value && HEX_OBJECT_ID.test(value);
const isUlid = (value) => !!value && ULID.test(value);
const investigationResolver = {
  uriSegment: "investigations",
  resolve: (segments) => {
    const [id] = segments;
    if (!isObjectId(id)) {
      return null;
    }
    return { onClick: ({ openSidebar }) => openSidebar(SidebarInvestigationDetails(id)) };
  }
};
const assetResolver = {
  uriSegment: "assets",
  // The agent emits `graylog:///assets/<type>/<id>`. We don't differentiate asset subtypes
  // here — the asset sidebar fetches the asset by id and renders the subtype itself, so the
  // <type> URI segment is ignored and we take the id from the end of the path.
  resolve: (segments) => {
    const id = segments[segments.length - 1];
    if (!isObjectId(id)) {
      return null;
    }
    return {
      onClick: ({ openSidebar }) => openSidebar({
        id: `asset-${id}`,
        title: "Asset Details",
        componentKey: "AssetSidebarContent",
        props: { assetId: id }
      })
    };
  }
};
const securityEventResolver = {
  uriSegment: "events",
  // Security event ids are ULIDs (26-char Crockford base32), NOT 24-char hex ObjectIds.
  // Validate accordingly so a malformed agent reference doesn't slip through, but don't
  // accidentally reject every real id by reusing the ObjectId check.
  resolve: (segments) => {
    const [id] = segments;
    if (!isUlid(id)) {
      return null;
    }
    return {
      onClick: ({ openSidebar }) => openSidebar({
        id: `event-${id}`,
        title: "Event",
        componentKey: "EventReplaySideBarDetails",
        props: { alertId: id }
      })
    };
  }
};
const eventDefinitionResolver = {
  uriSegment: "event-definitions",
  // Opens the EventDefinitionSideBarDetails component in the right sidebar. The component is
  // registered under the `EventDefinitionSideBarDetails` key in `security-app/bindings.tsx`
  // and takes a `definitionId` prop.
  resolve: (segments) => {
    const [id] = segments;
    if (!isObjectId(id)) {
      return null;
    }
    return {
      onClick: ({ openSidebar }) => openSidebar({
        id: `event-definition-${id}`,
        title: "Event Definition",
        componentKey: "EventDefinitionSideBarDetails",
        props: { definitionId: id }
      })
    };
  }
};
const entityLinkResolvers = [
  investigationResolver,
  assetResolver,
  securityEventResolver,
  eventDefinitionResolver
];
export default entityLinkResolvers;
